import { RadioCardGroup } from './RadioCardGroup';

export function LanguageSelector({ language, options, onLanguageChange }) {
  return (
    <RadioCardGroup
      label="Language"
      ariaLabel="Template Language"
      options={options}
      value={language}
      onChange={onLanguageChange}
    />
  );
}
